

export const productData = [
    {
        image: 'product1.png',
        name: 'EDUCATION',
        title: 'kindertown',
        category: 'eduCategory',
        description: "eduDescription",
        description2: "",
        description3: "",
        descriptionMobile: "edudescriptionMobile",
        specifications: {
            versions: ['KT Parent', 'KT Teacher', 'KT Admin'],
            devices: ['Mobile phone', 'iPad / Tablet', 'PC', 'Mac'],
            operating: ['iOS', 'iPad OS', 'Mac OS', 'Android', 'Window'],
            security: ['Face ID', 'Fingerprint', 'Login ID', 'Password'],
            parent: ['Attendance', 'Reservation', 'Affiliate', 'Search kindergarten', 'Kids mission', 'Attractive widgets', 'Daily activities', 'Online payment', 'Market place', 'Community', 'Notice box', 'Skill assessment', 'Class info', 'Timetable', 'Transportation services', 'Insurance services'],
            teacher: ['Teacher smart dash', 'Academic calendar', 'Student listing', 'Student details', 'Attendance reports', 'My schedule', 'Daily task', 'Exam grade', 'Create activities', 'Create Task', 'Photo collection', 'Community'],
            admin: ['Admin smart dash', 'Teacher & Student data', 'School fees report', 'Academic calendar', 'Configuration setting', 'Enrol new student', 'Reservations & Registrations', 'Student profile', 'Billing & Invoice', 'Teacher profile & Payslip', 'Teacher task board', 'Attendance reports', 'Transaction history', 'Admin user setting'],
        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            parent: 'featureParent',
            teacher: 'featureTeacher',
            admin: 'featureAdmin',
        },
        summary:
            'eduSummary',
        summary2:
            'eduSummary2',
        summaryMobile:
            'eduSummaryMobile',
        summaryMobile2:
            'eduSummaryMobile2',
    },
    {
        image: 'product2.png',
        name: 'E-INVOICE',
        title: 'eInbill',
        category: 'eInvoiceCategory',
        description:
            "eInvoiceDescription",
        description2: "",
        description3: "",
        descriptionMobile: "eInvoiceDescription",
        specifications: {
            versions: ['E-Admin', 'E-Merchant', 'E-Mobile'],
            plan: ['Basic', 'Standard', 'Advanced'],
            devices: ['Mobile phone', 'iPad / Tablet', 'PC', 'Mac'],
            operating: ['iOS', 'iPad OS', 'Mac OS', 'Android', 'Window'],
            security: ['Face ID', 'Fingerprint', 'Login ID', 'Password'],
            features: ['Software license', 'Mobile printer', 'Paper roll', 'Mobile POS device', 'Smart POS device', 'USB + Bluetooth', 'NFC compatible', 'QR scan', 'Wifi supported', '2G / 3G / 4G / LTE', 'Li-ion battery', 'Camera rear 5MP', 'Customisable menu', 'Unlimited invoices', 'Cloud storage', 'Automatic cutter', 'Training & Support'],
        },
        sectionTitles: {
            versions: 'versions',
            plan: 'plan',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            features: 'features',
        },
        summary:
            'eInvoiceSummary',
        summary2:
            'eInvoiceSummary2',
        summaryMobile:
            'eInvoiceSummaryMobile',
        summaryMobile2:
            'eInvoiceSummaryMobile2',
    },
    {
        image: 'product3.png',
        name: 'ATTENDANCE',
        title: 'motionCapture',
        category: 'attendenceCategory',
        description: "attendenceDescription",
        description2: "",
        description3: " ",
        descriptionMobile: "attendenceDescriptionMobile",
        specifications: {
            versions: ['Mocap employee', 'Mocap employer'],
            devices: ['Mobile phone', 'PC', 'Mac'],
            operating: ['iOS', 'Android', 'Window'],
            security: ['Face ID', 'Fingerprint', 'Employee ID', 'Employer ID', 'Password'],
            featuresEmployee: ['Employee smart-app', 'Attendance', 'Announcement', 'Flexi-work', 'Incentive & Rewards', 'Notification', 'Vote function', 'Top attendance', 'Billboard', 'Pool benefits', 'Performance chart', 'Yearly bonus', 'Salary increase', 'Project chart', 'Tasking chart', 'Point redeem', 'Leave & claim', 'Employee profile', 'Birthday rewards', 'Department chart'],
            featuresEmployer: ['Employer smart dash', 'Attendance report', 'Interview form', 'Request report', 'Employee smart data', 'Performance data', 'Calendar Setting', 'Project & Task creation', 'Progress chart', 'Department creation', 'Department listing', 'Employee listing', 'Salary profile', 'Project QC', 'Announcement', 'User authority', 'Overtime setting', 'Activity logs'],

        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            featuresEmployee: 'featuresEmployee',
            featuresEmployer: 'featuresEmployer',

        },
        summary:
            'attendenceSummary',
        summary2:
            'attendenceSummary2',
        summaryMobile:
            'attendenceSummaryMobile',
    },
    {
        image: 'product4.png',
        name: 'FINANCE',
        title: 'smartCMS',
        category: 'financeCategory',
        description: "financeDescription",
        description2: "financeDescription2",
        description3: "financeDescription3",
        descriptionMobile: "financeDescriptionMobile",
        descriptionMobile2: "financeDescriptionMobile2",
        specifications: {
            versions: ['Smart member', 'Smart master'],
            devices: ['Mobile phone', 'PC', 'Mac'],
            operating: ['Window', 'Web'],
            security: ['Fingerprint', 'Master ID', 'Admin ID', 'Member ID', 'Password'],
            featuresMember: ['Member smart dash', 'In-app digital e-wallet', 'Build-in payment channel', 'Rebate earning', 'Account overview', 'Trading account creation', 'Check-in rewards', 'Data chart', 'IB program', 'Level structure', 'Transaction history', 'Rebate adjustment', 'PAMM integrate', 'Copytrade integrate'],
            featuresMaster: ['Master smart dash', 'Credit adjustment', 'Announcement creation', 'withdrawal request', 'Net asset data', 'In & out report', 'Account configuration', 'Limitation setting', 'Forum creation', 'IB group data', 'Performance fee', 'Rebate adjustment', 'Competition', 'PAMM setting', 'Copytrade'],

        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            featuresMember: 'featuresMember',
            featuresMaster: 'featuresMaster',

        },
        summary:
            'financeSummary',
        summary2:
            'financeSummary2',
        summaryMobile:
            'financeSummaryMobile',
        summaryMobile2:
            'financeSummaryMobile2',
        summaryMobile3:
            'financeSummaryMobile3',
    },
    {
        image: 'product5.png',
        name: 'STOCKIES',
        title: 'beverage',
        category: 'stockiesCategory',
        description: "stockiesDescription",
        description2:"",
        description3: "",
        descriptionMobile: "stockiesDescriptionMobile",
        specifications: {
            versions: ['Admin', 'Staff', 'Customer'],
            plan: ['With E-invoice', 'Without E-invoice'],
            devices: ['Mobile phone', 'iPad / Tablet', 'PC', 'Mac'],
            operating: ['iOS', 'iPad OS', 'Mac OS', 'Android', 'Windows'],
            security: ['Face ID', 'Fingerprint', 'Login ID', 'Password'],
            features: ['Stock control', 'Stock reminder', 'Order record', 'Menu creation', 'Member area', 'Point system', 'Keep record', 'Table & room', 'Attendance', 'Commission', 'Reservation', 'Sales Data', 'Sales report', 'Loyalty Programme', 'E-invoice', 'Promotion'],
        },
        sectionTitles: {
            versions: 'versions',
            plan: 'plan',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            features: 'features',
        },
        summary:
            "stockiesSummary",
        summary2:
            'stockiesSummary2',
        summaryMobile:
            "stockiesSummaryMobile",
        summaryMobile2:
            'stockiesSummaryMobile2',
        summaryMobile3:
            'stockiesSummaryMobile3',
    },
    {
        image: 'product6.png',
        name: 'BROKERAGE',
        title: 'brokerage',
        category: 'brokerageCategory',
        description: "brokerageDescription",
        description2: "brokerageDescription2",
        description3: "",
        descriptionMobile: "brokerageDescriptionMobile",
        specifications: {
            versions: ['MQ clients terminal', 'MQ Administrator', 'cTrader', 'cBroker'],
            devices: ['Mobile phone', 'iPad / Tablet', 'PC', 'Mac'],
            operating: ['iOS', 'iPad OS', 'Mac OS', 'Android', 'Web', 'Window'],
            security: ['Face ID', 'Fingerprint', 'Login ID', 'Password'],
            featuresClient: ['Brokers search', 'Live & Demo account', 'Leverage up to 1:500', 'MQL4 & MQL5', 'Allow auto trading', '9 timeframes', '3 chart types', '30+ Indicators', 'MQ community', 'One click trading'],
            featuresAdmin: ['Price feed integration', 'Group creation', 'Spread adjustment', 'Allow edit chart', 'Allow edit pricing', 'Market price modify', 'Allow internal transfer', 'Clients listing & data', 'Margin setting', 'Market chart modify', 'Symbol creation', 'Modify history data'],
            featuresCtrader: ['Login by CTID', 'Live & Demo account', 'Leverage up to 1:1000', 'C# Autobot', 'In-app deposit', 'Allow auto trading', '26 timeframes', '8 chart types', '70+ Indicators', 'cTrader community', 'One click trading', 'In-app copytrading', 'Economic news'],
            featuresCbroker: ['Price feed integration', 'Group creation', 'Spread adjustment', 'Allow edit chart', 'Account setting', 'Clients listing & data', 'Allow internal transafer', 'Margin setting', 'Market chart modify', 'Symbol creation'],

        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            featuresClient: 'featuresClient',
            featuresAdmin: 'featuresAdmin',
            featuresCtrader: 'featuresCtrader',
            featuresCbroker: 'featuresCbroker',
        },
        summary:
            'brokerageSummary',
        summary2:
            'brokerageSummary2',
        summaryMobile:
            'brokerageSummaryMobile',
        summaryMobile2:
            'brokerageSummaryMobile2',
    },
    {
        image: 'product7.png',
        name: 'EA BUILDER',
        title: 'autoTradingBots',
        category: 'EABuilderCategory',
        description: "EABuilderDescription",
        description2: "EABuilderDescription2",
        description3: "EABuilderDescription3",
        descriptionMobile: "EABuilderDescriptionMobile",
        specifications: {
            versions: ['MQL4', 'MQL5', 'cALGO'],
            devices: ['PC', 'Mac'],
            operating: ['Window', 'MetaTrader 4', 'MetaTrader 5', 'cTrader'],
            security: ['Login ID', 'Password', 'CTID'],
            featuresEaStrategy: ['Trend Following', 'Scalping', 'Mean Reversion', 'Breakout', 'Oscillator-Based', 'Anti-Martingale', 'Martingale', 'Arbitrage', 'Grid Trading', 'News Trading', 'Hedging', 'Hedging Martingale', 'Hybrid', 'Multi-Timeframe', 'Momentum', 'Time-Based'],

            
        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            featuresEaStrategy: 'featuresEaStrategy',
            
        },
        summary:
            'EABuilderSummary',
        summary2:
            'EABuilderSummary2',
        summaryMobile:
            'EABuilderSummaryMobile',
        summaryMobile2:
            'EABuilderSummaryMobile2',
    },
    {
        image: 'product8.png',
        name: 'COIN.WALLET',
        title: 'cryto',
        category: 'crytoCategory',
        description:
            "crytoDescription",
        description2: "crytoDescription2",
        description3: "crytoDescription3",
        descriptionMobile: "crytoDescriptionMobile",
        specifications: {
            versions: ['Master portal', 'Merchant portal'],
            devices: ['PC', 'Mobile phone', 'iPad / Tablet'],
            operating: ['Window', 'Web'],
            security: ['Face ID', 'Fingerprint', 'Login ID', 'Password'],
            features: ['Accept for any platform', 'Easy to integration', 'Receive & payment', 'Merchant listing', 'Smart dash', 'Low transaction fee', 'Low setup cost', '24 / 5 phone support ', 'Fund receive notification', 'Only one-way charge'],

            
        },
        sectionTitles: {
            versions: 'versions',
            devices: 'device',
            operating: 'operatingSystem',
            security: 'biometric',
            features: 'crytoFeatures',
            
        },
        summary:
            'crytoSummary',
        summary2:
            'crytoSummary2',
        summaryMobile:
            'crytoSummaryMobile',
        summaryMobile2:
            'crytoSummaryMobile2',
    },
];
